import { FC } from "react"
import { AlertResponse } from "@/api/AlertsService"
import NumberBadge from "@/components/NumberBadge"
import { Icon, IconColor } from "@/components/shared/Icon"
import { AlertSource, AlertVariant } from "@/types/alert"
import { AlertSystemConditionType } from "@/types/alertConfigurations"
import { getAlertSystemConditionTypeIconName } from "@/utils/alertConfiguration"
import { getAlarmDisplayName } from "@/utils/alerts"

export interface AlertCellProps {
   alarm: AlertResponse | null
}

const AlertCell: FC<AlertCellProps> = ({ alarm }) => {
   if (!alarm) {
      return
   }
   const { priority, alertConfiguration } = alarm

   const color =
      alertConfiguration.color.card.toLowerCase() as keyof typeof AlertVariant

   const iconName = alertConfiguration.systemCondition
      ? getAlertSystemConditionTypeIconName(
           alertConfiguration.systemCondition.type as AlertSystemConditionType
        )
      : ""

   return (
      <div className="wearables-overview__alert-cell">
         <NumberBadge
            number={priority}
            alertVariant={color}
         />
         {iconName && (
            <Icon
               name={iconName}
               size="16"
               color={IconColor.HONOLULU_BLUE}
            />
         )}
         <span>
            {getAlarmDisplayName(
               alertConfiguration.name,
               alertConfiguration.systemCondition?.type,
               { source: AlertSource.WEARABLE }
            )}
         </span>
      </div>
   )
}

export default AlertCell
